import { Component, Vue } from "vue-property-decorator";
import { TranslationHelper } from "@/utils/TranslationHelper";
import { JSONSchema6 } from "json-schema";

/**
 * Abstract basic cpt edit functionality
 * shared between mods and anons
 */
@Component
class CPTEditModerateMixin extends Vue {
  /**
   * Indicates if form is valid
   */
  public valid = false;

  /**
   * Is in preview mode
   */
  public previewMode = false;

  /**
   * base schema getter
   */
  get baseSchema(): JSONSchema6 {
    console.warn(
      "You should override the baseSchema getter when implementing CPTEditModerateMixin mixin"
    );
    return {};
  }

  /**
   * Form options
   */
  // eslint-disable-next-line
  get formOptions(): any {
    return {
      castToSchemaType: true,
      showValidationErrors: true,
      validateOnLoad: true,
      // https://jarvelov.gitbook.io/vue-form-json-schema/api/vue-form-json-schema/options/ajv
      ajv: {
        options: {
          schemas: [this.baseSchema],
        },
        locale: TranslationHelper.getAjvTranslations(),
      },
    };
  }

  /**
   * update the forms valid value
   */
  public onValidated(valid: boolean): void {
    this.valid = valid;
  }
}
export default CPTEditModerateMixin;
